export const createAppSlice = set => ({
  storageRange: 0,
  setStorageRange: storageRange =>
    set(state => ({
      ...state,
      storageRange,
    })),
  transferRange: 0,
  setTransferRange: transferRange =>
    set(state => ({
      ...state,
      transferRange,
    })),
  scalewayVariant: 'single',
  setScalewayVariant: scalewayVariant =>
    set(state => ({
      ...state,
      scalewayVariant,
    })),
  bunnyVariant: 'hdd',
  setBunnyVariant: bunnyVariant =>
    set(state => ({
      ...state,
      bunnyVariant,
    })),
});
